import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import SpreadsheetModelEditDto from '../dto/SpreadsheetModelEditDto';

class SpreadsheetModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'spreadSheetModelEditControl';
	}

	/**
	 * @param {string} driverName
	 * @return {Promise<AnnModelEditDto>}
	 */
	create(driverName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/create`, { driverName })
				.then(response => resolve(new SpreadsheetModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<AnnModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new SpreadsheetModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {AnnModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {AnnModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} xlsFile
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	addModelEntry(id, xlsFile) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addModelEntry`, {
					id,
					xlsFile
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new SpreadsheetModelEditService();